import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-product-storage-history-dialog',
  templateUrl: './product-storage-history-dialog.component.html',
})
export class ProductStorageHistoryDialogComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
